
import { initializeApp, getApp, getApps } from '@firebase/app';
import { getAuth } from '@firebase/auth';
import { getFirestore } from '@firebase/firestore';
import { getFunctions } from '@firebase/functions';
import { getStorage } from '@firebase/storage';
import { firebaseConfig } from './firebaseConfig';

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

const auth = getAuth(app);

// Use the default Firestore instance for everything
const db = getFirestore(app);
// Alias defaultDb to the same instance for compatibility
const defaultDb = db;

const functions = getFunctions(app, 'us-central1');

// IMPORTANTE: Forzamos el uso del bucket configurado para evitar errores de CORS por dominios ambiguos
const storage = getStorage(app, firebaseConfig.storageBucket);

export { app, auth, db, defaultDb, functions, storage };
